import { Link } from "react-router-dom";
import { useTheme } from "@/lib/theme";

export default function MarketingFooter() {
  const { branding } = useTheme();
  return (
    <footer className="border-t border-border/50 mt-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 py-16 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-3" data-testid="marketing-footer-brand">
            <div className="w-8 h-8 rounded-sm bg-primary text-primary-foreground flex items-center justify-center font-black overflow-hidden shrink-0">
              {branding.logo_icon_url ? (
                <img src={branding.logo_icon_url} alt={branding.platform_name} className="w-full h-full object-cover" />
              ) : branding.logo_url ? (
                <img src={branding.logo_url} alt={branding.platform_name} className="w-full h-full object-cover" />
              ) : (
                (branding.platform_name || "A").slice(0, 1)
              )}
            </div>
            <span className="font-bold tracking-tight text-base" style={{ fontFamily: "var(--font-heading)" }}>
              {branding.platform_name}<sup className="text-[0.5em] ml-0.5 opacity-70">™</sup>
            </span>
          </div>
          <p className="text-sm text-muted-foreground max-w-xs">{branding.tagline}</p>
        </div>
        <div>
          <h4 className="label-eyebrow mb-3">Product</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/features" className="hover:text-primary">Features</Link></li>
            <li><Link to="/pricing" className="hover:text-primary">Pricing</Link></li>
            <li><Link to="/solutions" className="hover:text-primary">Solutions</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="label-eyebrow mb-3">Trust</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/security" className="hover:text-primary">Security</Link></li>
            <li><Link to="/legal/dpa" className="hover:text-primary">DPA</Link></li>
            <li><Link to="/legal/subprocessors" className="hover:text-primary">Subprocessors</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="label-eyebrow mb-3">Legal</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/legal/terms" className="hover:text-primary" data-testid="footer-link-terms">Terms &amp; Conditions</Link></li>
            <li><Link to="/legal/privacy" className="hover:text-primary" data-testid="footer-link-privacy">Privacy</Link></li>
            <li><Link to="/legal/cookies" className="hover:text-primary">Cookies</Link></li>
            <li><Link to="/legal/refund" className="hover:text-primary" data-testid="footer-link-refund">Refunds &amp; Cancellations</Link></li>
            <li><Link to="/legal/aup" className="hover:text-primary">Acceptable use</Link></li>
            {/* Feb 2026 · Contact Us is a Cashfree merchant disclosure
                requirement. Lives alongside the other policy pages so
                the required set — Contact / Terms / Refunds — is
                reachable in one place from every marketing page. */}
            <li><Link to="/legal/contact" className="hover:text-primary" data-testid="footer-link-contact">Contact Us</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border/50 py-6 px-6 sm:px-10 max-w-7xl mx-auto text-xs text-muted-foreground flex flex-col md:flex-row gap-2 justify-between">
        <span>© {new Date().getFullYear()} {branding.platform_name}<sup className="text-[0.6em] ml-0.5 opacity-70">™</sup>. All rights reserved.</span>
        <span>Pune · Maharashtra · India</span>
      </div>
    </footer>
  );
}
